export default {
  apiKey: "AIzaSyB0S_u2vWxNEbp9Y_tI1EKAwoQ6CM1Leb4",
  authDomain: "tachikawa-engekisai.firebaseapp.com",
  databaseURL: "https://tachikawa-engekisai.firebaseio.com",
  projectId: "tachikawa-engekisai",
  storageBucket: "tachikawa-engekisai.appspot.com",
  messagingSenderId: "299304529473",
  appId: "1:299304529473:web:44cb9ecaa277edd8",
};
// export default {
//   apiKey: 'AIzaSyBBAJzRRMvGyeg9AxFRGyUJ-UsWO0lNJFM',
//   authDomain: 'tachikawa-theatre-festival.firebaseapp.com',
//   databaseURL: 'https://tachikawa-theatre-festival.firebaseio.com',
//   projectId: 'tachikawa-theatre-festival',
//   storageBucket: 'tachikawa-theatre-festival.appspot.com',
//   messagingSenderId: '601204464343',
//   appId: '1:601204464343:web:7cc0a0a5f8e5927e',
// };
// export default {
// apiKey: "AIzaSyAqwpZvUmiuuExw93Cv4ex5Ild89WUFzBU",
// authDomain: "ttf-blog.firebaseapp.com",
// databaseURL: "https://ttf-blog.firebaseio.com",
// projectId: "ttf-blog",
// storageBucket: "ttf-blog.appspot.com",
// messagingSenderId: "557772270319",
// appId: "1:557772270319:web:3201a5f9e9e0b41d",
// };